module.exports = __webpack_public_path__ + "img/home-kids-s2.47fc06fe.png";